import styled from "styled-components";
// import LinkHandler from "./../LinkHandler";

const StyledImageContainer = styled.a`
  display: block;
  position: relative;
`;

const StyledStaticImageContainer = styled.div`
  display: block;
  position: relative;
`;

const Gradient = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 8e-5) 35.03%,
    rgba(0, 0, 0, 0.0533333) 48.04%,
    rgba(0, 0, 0, 0.169412) 59.79%,
    rgba(0, 0, 0, 0.326275) 70.29%,
    rgba(0, 0, 0, 0.492549) 79.54%,
    rgba(0, 0, 0, 0.646275) 87.58%,
    rgba(0, 0, 0, 0.756078) 94.39%,
    rgba(0, 0, 0, 0.8) 100%
  );
`;

const GradientAmp = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 8e-5) 35.03%,
    rgba(0, 0, 0, 0.0533333) 48.04%,
    rgba(0, 0, 0, 0.169412) 59.79%,
    rgba(0, 0, 0, 0.326275) 70.29%,
    rgba(0, 0, 0, 0.492549) 79.54%,
    rgba(0, 0, 0, 0.646275) 87.58%,
    rgba(0, 0, 0, 0.756078) 94.39%,
    rgba(0, 0, 0, 0.8) 100%
  );
`;

const StyledButton = styled.div`
  position: relative;
`;

export { StyledStaticImageContainer, StyledImageContainer, Gradient, GradientAmp, StyledButton };
